import { createApp, h } from 'vue';
import App from './App.vue';
import 'amfe-flexible';
import Vant from 'vant';
import { Toast } from 'vant';
import 'vant/lib/index.css';
import router from '@/router';
import 'lib-flexible';
import store from '@/store/index';
import VueClipboard from 'vue-clipboard2';

(function () {
  if (typeof window.WeixinJSBridge == "object" && typeof window.WeixinJSBridge.invoke == "function") {
    handleFontSize();
  } else {
    if (document.addEventListener) {
      document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
    } else if (document.attachEvent) {
      //IE浏览器，非W3C规范
      document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
    }
  }

  function handleFontSize() {
    // 设置网页字体为默认大小
    window.WeixinJSBridge.invoke('setFontSizeCallback', {
      'fontSize': 0
    }); // 重写设置网页字体大小的事件

    window.WeixinJSBridge.on('menu:setfont', function () {
      window.WeixinJSBridge.invoke('setFontSizeCallback', {
        'fontSize': 0
      });
    });
  }
})();

const app = createApp({
  render: () => h(App),

  created() {},

  watch: {
    // 监听路由 控制侧边栏显示 标记当前顶栏菜单（如需要）
    '$route'(to, from) {
      if (to.meta.title) {
        document.title = to.meta.title;
      }
    }

  }
});
app.use(router);
app.use(store);
app.use(Vant);
app.use(Toast);
app.use(VueClipboard);
app.mount('#app');